module.exports = __webpack_public_path__ + "static/media/ringing.e841c397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ringing.svg
// module id = 369
// module chunks = 0